/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes, { object } from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import './formJSONComponent.scss';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Icon, { IconType } from '../../atoms/icon/icon';
import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import FormJSONComponent from './formJSONComponent';
import Accordion from '../../molecules/accordion/accordion';
import { LoadDownloadableImageFile } from '../../../utils/urlTools';
import { mapDispatchToProps } from '../../../store/externalCalls/api/uploadFilesApi';
import FormExternalResource from '../formExternalResource/formExternalResource';


const FormJSONBlock = (props) => {
  const {
    fields,parent,parentId,value,configFile, onChange,onDelete,onEdit,params,uniqueId,parentUID,canRemove,canEdit,getItemDonwloadable,
    onPopupOpenned,extraValues,formGroupValue
  } = props;

  const [valueState, setValueState] = useState(value);
  const [uID,setUID]=useState(uniqueId);

  if (value !== valueState) {
    setValueState(value);
  }

  const handlerRelatedOnChangeJSONObject=(field,id,valuesJson,parent,parentId)=>{
    onChange(field,id,valuesJson,parent,parentId);
  };

  const handlerEdit=()=>{
    const attributeName=configFile.attributeName;
    onEdit(attributeName,value["id"]);
  }
  const handlerDelete=()=>{
    const parent=configFile.attributeName;
    onDelete(parent,value["id"],parentId);
  }
  const isVisibleWhen=(el,value)=>{
    if(el.visibleWhen){
        if(Array.isArray(el.visibleWhen)){
          let arrVisible=true;
          el.visibleWhen.forEach((elArr)=>{
            if(elArr.value=="bool-false"){
              if(value[elArr.field]==1 || value[elArr.field]==true){
                arrVisible=false;
              }
            }else if(elArr.value=="not-null"){
              if(value[elArr.field]==0 || value[elArr.field]=="" ||value[elArr.field]==undefined){
                arrVisible=false;
              }
            } 
            else if(value[elArr.field]!=elArr.value){
              arrVisible=false;
            }
            
          });
          return arrVisible;
        }else{
          if(value[el.visibleWhen.field]==el.visibleWhen.value){
            return true; 
          }else
            return false;
          }
          return true;
    }else
      return true;
  }
  
  return (
     <Accordion className={configFile.attributeName+" "+configFile.attributeName+"-"+value["id"]+' accordion-test'} title={(configFile.itemLabel && value?configFile.itemLabel+" "+value["id"]:"Element")} helpText={configFile.helpText}
        rightBlockElement={
          <div className={`main-row main-row--actions`}>
            {canEdit && <Button
              className={"button-openButton "+"button-openButton-"+value["id"]+" mr-1" }
              theme={ButtonTheme.INFO}
              icon={IconType.EDIT}
              title='edit'
              onClick={handlerEdit}
            />}
            {canRemove && <Button
              theme={ButtonTheme.ERROR}
              className={"button-removeButton "+"button-removeButton-"+value["id"]}
              icon={IconType.DELETE}
              title='delete'
              onClick={handlerDelete}
            />}
          </div>
    }>
      <div className={`main-body`}>
        <div className={`body col-sm-12 d-flex flex-wrap` }>
          {fields && fields.map((el,index)=>{
            if(el.type!=FormInputTypes.JSON_COMPONENT){
              if(!el.hidden && isVisibleWhen(el,value)){
              switch(el.type){
                case FormInputTypes.DOWNLOADABLE:
                  return (
                  <div  key={el.attributeName+"-"+index} className={"body-field "+(el.className?el.className:"")+ ' '+el.attributeName+ " "+el.attributeName+"-"+value["id"] }>
                    <FormExternalResource
                      id={`${el.attributeName}`}
                      type={'downloadable'}
                      key={el.attributeName+"-"+index}
                      hasSelect={false}
                      label={el.label}
                      helpText={el.helpText}
                      canUpload={false}
                      canDelete={false}
                      noImageText={value && value[el.attributeName]?"":"No image selected"}
                      loadingText={value && value[el.attributeName]?"loading...":""}
                      // fileType={field.fileType}
                      value={value ? value[el.attributeName] : ''}
                      size="L"
                    />
                  </div>);
                break;
                case FormInputTypes.SEPARATOR:
                  return (<hr style={{width:'100%'}} key={index}/>);
                break;
                case FormInputTypes.STATIC_TEXT:
                  return ;
                  
                case FormInputTypes.TEXT_INPUT.URLPREVIEW:
                  return <div key={el.attributeName} className={'body-field col-sm-6 ' +el.attributeName+ " "+el.attributeName+"-"+value["id"]}>{el.label}: 
                            <img className="map-image" 
                              src={value[el.attributeName]} />
                          </div>
                case FormInputTypes.CHECKBOX:
                  return (
                    <div key={el.attributeName} className={'body-field col-sm-6 ' + el.attributeName + " " + el.attributeName + "-" + value["id"]}>
                      <div className='body-field--label'>{el.label} :</div>
                      <div className='body-field--value'>
                        <span>
                          {String(Boolean(value?.[el.attributeName]))}
                        </span>
                      </div>
                    </div>
                  );
                default:
                  return <div key={el.attributeName} className={'body-field col-sm-6 ' +el.attributeName+ " "+el.attributeName+"-"+value["id"]}>
                           <div className='body-field--label'>{el.label} : </div> 
                           <div className={`body-field--value`}> <span>{value[el.attributeName]} </span></div>
                         </div>
              }
              }
             
            }else{
              const newExtraValues = {...extraValues};
              if(el.extraValues && el.extraValues.length > 0){
               el.extraValues.forEach((extraValue) => {
                if(value[extraValue]){
                  newExtraValues[extraValue] = value[extraValue];
                }
               });
              }

              if (el?.visibleWhen && value) {
                
                let fields = el.visibleWhen;
                let result = true;

                if (Array.isArray(fields)) {
                  fields.forEach((element) => {
             
                    if (element) {
                      if (element.value === "not-null") {
                        if (value[element.field] === "" || value[element.field] === null) {
                          result = false;
                        }
                      } else if (value[element.field] != element.value) {
                        result = false;
                      }
                    }
                  });

                  if (!result) {
                    return null;
                  }

                }

              }
          
              if (el?.disableWhen && value) {

                let fields = el.disableWhen;
                let result = false;

                if (Array.isArray(fields)) {
                  fields.forEach((element) => {

                    let fieldValue = value?.[element.field];

                    if (element.value === "not-null") {
                      if (fieldValue !== "" && fieldValue !== null && fieldValue !== undefined ) {
                        
                        result = true;
                      }
                    } 
                  });
                }

                if(!result){
                 
                  if(value.hasOwnProperty(el.attributeName)){
                    value[el.attributeName]= [];              
                  }
                  return null;
                }

              }
              return <FormJSONComponent canCreate={el.canCreate} canRemove={el.canRemove} 
              formGroupValue = {formGroupValue}
              mode="related" parentId={value["id"]} id={value["id"]} key={el.attributeName} 
              parent={parent} field={el.attributeName} configFile={el} value={value[el.attributeName]} 
              params={params} uniqueId={uID} parentUID={uniqueId} extraValues={newExtraValues} classCss={el.classCss}
              onChangeJsonObject={handlerRelatedOnChangeJSONObject} 
              onPopupOpenned={onPopupOpenned} />
            }
          })}
        </div>
      </div>
    </Accordion>
  );
};

FormJSONBlock.propTypes = {
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  onNew:PropTypes.func,
};

FormJSONBlock.defaultProps = {
  errorText: '',
  label: '',
  helpText: '',
  value: {},
  fields:{},
  onChange: () => {},
};

// export default FormJSONBlock;
export default connect(null, mapDispatchToProps)(FormJSONBlock);

